<div class="container-fluid">
  <div class="row">
    <div class="col-xl-4 col-lg-5 col-sm-12 my-2 d-inline-flex">
      <form [formGroup]="searchForm" class="text-secondary col-xl-12 col-lg-12 col-sm-12" (ngSubmit)="onSubmit()">
        <label class="mx-1">Nom</label>
        <div class="input-group">
          <div class="mb-2 mx-1 px-0 d-flex col-xl-7 col-lg-7 col-sm-6">
            <input class="form-control" type="text" formControlName="search" />
          </div>
          <div class="d-grid px-0 mx-1">
            <button type="submit" class="btn btn-primary">Rechercher</button>
          </div>
        </div>
      </form>
    </div>
    <span class="col-sm-0 col-xl-5 col-lg-3 col-sm-12"></span>
    <div class="py-4 mt-2 col-sm-12 col-xl-3 col-lg-4 d-flex flex-row-reverse">
      <button type="button" class="mb-2 mx-1 btn btn-primary" (click)="onExportToCsv()" *appOnlyGroups="['ADMIN']">Export CSV</button>
      <button type="button" class="mb-2 mx-1 btn btn-primary" (click)="openModal()" *appOnlyGroups="['ADMIN']">Ajouter un utilisateur</button>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col px-0">
      <table class="table table-striped table-hover" aria-describedby="usersTitle">
        <thead class="text-secondary bg-light">
          <tr>
            <th></th>
            <th scope="col" sortable="profileLabel" (sort)="onSort($event)">Profil</th>
            <th scope="col" sortable="email" (sort)="onSort($event)">Email</th>
            <th scope="col" sortable="lastname" (sort)="onSort($event)">Nom</th>
            <th scope="col" sortable="firstname" (sort)="onSort($event)">Prénom</th>
            <th scope="col" sortable="profileDetails" (sort)="onSort($event)">Détails profil</th>
            <th scope="col" class="text-center" sortable="active" (sort)="onSort($event)">Actif</th>
          </tr>
        </thead>
        <tbody>
          @for (user of users.items; track user) {
            <tr (click)="openModal(user.id)">
              <td></td>
              <td>{{ user.profileLabel }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.lastname }}</td>
              <td>{{ user.firstname }}</td>
              <td>{{ user.profileDetails }}</td>
              <td class="text-center">{{ user.active ? 'Oui' : 'Non' }}</td>
            </tr>
          }
        </tbody>
      </table>
      @if (users.items.length === 0) {
        <p>Aucun utilisateur trouvé.</p>
      }
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <ngb-pagination
      [collectionSize]="users.totalItems"
      [page]="users.options.page"
      [pageSize]="users.options.limit"
      (pageChange)="changePage($event)"
      >
    </ngb-pagination>
    <select class="w-auto form-select" [ngModel]="users.options.limit" (change)="changeLimit($event)">
      <option [value]="10">10 éléments par page</option>
      <option [value]="25">25 éléments par page</option>
      <option [value]="50">50 éléments par page</option>
      <option [value]="100">100 éléments par page</option>
    </select>
  </div>
</div>
